import { Box } from '@mui/material';
import { useAtomValue } from 'jotai';
import { InstantSearch } from 'react-instantsearch';
import { useSearchClient } from '../../hooks/useSearchClient';
import { currentContextAtom } from '../../state';
import FilterUtils from '../../search/filters/filter.utils';
import SearchConfigure from '../../search/SearchConfigure';
import SearchPagination from '../../search/SearchPagination';
import useUpdateUiState from '../hooks/useUpdateHistoryUiState';
import DiscoveryNavigationWrapper from '../navigation/DiscoveryNavigationWrapper';
import useDiscoveryDefaultFilters from '../../hooks/useDiscoveryDefaultFilters';
import DiscoveryCompanyHits from './DiscoveryCompanyHits';
import { DISCOVERY_AS_BUYER_HITS_PER_PAGE } from './DiscoveryAsBuyerPage';

export default function SupplierDiscovery(): React.JSX.Element {
  const searchClient = useSearchClient();
  const index = import.meta.env.REACT_APP_ALGOLIA_COMPANY_INDEX;
  const { companyId } = useAtomValue(currentContextAtom);
  const { initialIndexUiState, updateUiState } = useUpdateUiState({ index });

  const defaultFilters = useDiscoveryDefaultFilters();
  const filters = `${defaultFilters} AND ${FilterUtils.GetSignedContractFilter('partners', companyId)}`;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <InstantSearch
        indexName={index}
        searchClient={searchClient}
        initialUiState={{
          [index]: initialIndexUiState,
        }}
        onStateChange={updateUiState}
      >
        <SearchConfigure filters={filters} index={index} hitsPerPage={DISCOVERY_AS_BUYER_HITS_PER_PAGE}>
          <DiscoveryNavigationWrapper attribute="product_families">
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                borderRadius: {
                  xs: 0,
                  sm: 6,
                },
                mx: {
                  xs: -1,
                  sm: 0,
                },
              }}
            >
              <DiscoveryCompanyHits />
              <SearchPagination />
            </Box>
          </DiscoveryNavigationWrapper>
        </SearchConfigure>
      </InstantSearch>
    </Box>
  );
}
